/* ═══════════════════════════════════════════════════════════════════════
   VISTA RAPIDA
   ─────────────────────────────────────────────────────────────────────────
   Elegir talla, parche y nombre no deberia costar una pagina entera. La
   hoja sube desde abajo con la camisa a la vista y todo lo que hay que
   decidir al lado. Al cerrarla la persona sigue donde estaba.

   La hoja sube —no aparece en el centro— porque el boton que la abre esta
   abajo en la tarjeta: el movimiento sale de donde estaba el dedo.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var hoja = document.getElementById("vista-rapida");
  if (!hoja) { return; }

  var cuerpo = hoja.querySelector("[data-vr-cuerpo]");
  var parchesBase = hoja.getAttribute("data-parches-url");
  var varJ = hoja.getAttribute("data-var-jugador");
  var varP = hoja.getAttribute("data-var-propio");
  var precioJ = hoja.getAttribute("data-precio-jugador");
  var precioP = hoja.getAttribute("data-precio-propio");

  var cache = {};
  var actual = null;
  var sel = { parche: "Sin parches", modo: "sin", jugador: "", dorsal: "" };

  function plata(c) {
    return "₡" + (c / 100).toLocaleString("es-CR", { maximumFractionDigits: 0 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  function grande(u, px) {
    return u ? u.replace(/(\.[a-z]+)(\?|$)/i, "_" + px + "x$1$2") : "";
  }
  function todos(sel2, raiz) {
    return Array.prototype.slice.call((raiz || cuerpo).querySelectorAll(sel2));
  }

  function traer(handle) {
    if (cache[handle]) { return Promise.resolve(cache[handle]); }
    return fetch("/products/" + handle + ".js")
      .then(function (r) { if (!r.ok) { throw new Error("no"); } return r.json(); })
      .then(function (d) { cache[handle] = d; return d; });
  }

  function llevaPers(p) {
    var t = (p.type || "").toLowerCase();
    return t.indexOf("jacket") === -1 && t.indexOf("chaqueta") === -1 &&
           t.indexOf("conjunto") === -1 && t.indexOf("entrenamiento") === -1 &&
           t.indexOf("accesorio") === -1 && t.indexOf("servicio") === -1 &&
           p.handle.indexOf("personalizacion") === -1;
  }

  function datosDe(handle) {
    var d = window.TLR_DATOS;
    if (!d || !d.h || d.h[handle] === undefined) { return null; }
    return d.g[d.h[handle]];
  }

  function htmlParches(lista) {
    if (!lista || lista.length < 2) { return ""; }
    var opts = lista.map(function (o, k) {
      var corto = o.v.replace("Parches de ", "");
      corto = corto.charAt(0).toUpperCase() + corto.slice(1);
      var img = o.i && parchesBase
        ? '<img class="par-img" src="' + parchesBase + o.i + '.webp" alt="" loading="lazy" onerror="this.remove()">'
        : '<span class="par-img par-nada" aria-hidden="true"></span>';
      return '<button type="button" class="par" data-par="' + esc(o.v) + '" aria-pressed="' + (k === 0) + '">' +
             img + "<b>" + esc(corto) + "</b></button>";
    }).join("");
    return '<div class="grp">' +
      '<div class="grp-h"><span class="grp-t">Parches</span><span class="grp-v" data-valor>Sin parches</span></div>' +
      '<div class="par-opts" role="group" aria-label="Elegí los parches">' + opts + "</div>" +
      '<p class="grp-nota">Van incluidos, sin costo extra.</p></div>';
  }

  function htmlPers(plantilla) {
    var hayJug = plantilla && plantilla.length;
    var jugs = hayJug ? plantilla.map(function (j, k) {
      var pp = j.split("|");
      return '<button type="button" class="jug" data-jug="' + esc(pp[0]) + '" data-dorsal="' + esc(pp[1] || "") +
             '" aria-pressed="' + (k === 0) + '"><span class="jug-n">' + esc(pp[0]) + "</span>" +
             (pp[1] ? '<span class="jug-d">' + esc(pp[1]) + "</span>" : "") + "</button>";
    }).join("") : "";

    return '<div class="grp es-pers">' +
      '<div class="grp-h"><span class="grp-t">Nombre y número</span></div>' +
      '<div class="modos" data-modos role="group">' +
        '<button type="button" class="modo" data-modo="sin" aria-pressed="true">Sin nombre<small>Como viene</small></button>' +
        (hayJug ? '<button type="button" class="modo" data-modo="jugador" aria-pressed="false">Un jugador' +
          (precioJ ? "<small>+" + esc(precioJ) + "</small>" : "") + "</button>" : "") +
        '<button type="button" class="modo" data-modo="propio" aria-pressed="false">Tu nombre' +
          (precioP ? "<small>+" + esc(precioP) + "</small>" : "") + "</button>" +
      "</div>" +
      (hayJug ? '<div data-panel="jugador" hidden><div class="jugs" role="group">' + jugs + "</div></div>" : "") +
      '<div data-panel="propio" hidden><div class="campos">' +
        '<label>Nombre<input type="text" name="pers-nombre" maxlength="14" autocomplete="off" placeholder="NACHO"></label>' +
        '<label>Número<input type="text" name="pers-numero" maxlength="2" inputmode="numeric" autocomplete="off" placeholder="10"></label>' +
      "</div></div>" +
      '<p class="grp-nota">Vinilo termoestampado en la espalda.</p></div>';
  }

  function pintar(p) {
    actual = p;
    sel = { parche: "Sin parches", modo: "sin", jugador: "", dorsal: "" };

    var foto = grande(p.featured_image, 900);
    var opciones = p.options.map(function (o, i) {
      var valores = o.values.map(function (v, k) {
        return '<button type="button" class="chip" data-vr-op="' + i + '" data-vr-val="' + esc(v) +
               '" aria-pressed="' + (k === 0 ? "true" : "false") + '">' + esc(v) + "</button>";
      }).join("");
      return '<fieldset class="pdp-opt"><legend>' + esc(o.name) +
             '</legend><div class="seg" role="group">' + valores + "</div></fieldset>";
    }).join("");

    var reg = datosDe(p.handle);
    var extras = "";
    if (llevaPers(p)) {
      extras = htmlParches(reg && reg.pa) + htmlPers(reg && reg.pl);
      if (reg && reg.pl && reg.pl.length) {
        var pri = reg.pl[0].split("|");
        sel.jugador = pri[0];
        sel.dorsal = pri[1] || "";
      }
    }

    cuerpo.innerHTML =
      '<div class="vr-cols">' +
        '<a class="vr-foto ph" href="' + p.url + '">' +
          (foto ? '<img src="' + foto + '" alt="' + esc(p.title) + '" width="700" height="875">' : "") +
        "</a>" +
        '<div class="vr-info">' +
          '<span class="kicker">' + esc(p.type || "") + "</span>" +
          '<h2 class="display d-l">' + esc(p.title) + "</h2>" +
          '<p class="pdp-price" data-vr-precio>' + plata(p.price) + "</p>" +
          '<form class="pdp-form" data-vr-form>' + opciones + extras +
            '<button type="submit" class="btn btn-solid btn-lg" data-vr-add>Agregar al carrito</button>' +
            '<a class="btn btn-ghost btn-lg" href="' + p.url + '">Ver la ficha completa</a>' +
          "</form>" +
        "</div>" +
      "</div>";

    refrescar();
  }

  function elegidas() {
    return todos(".pdp-opt").map(function (fs) {
      var on = fs.querySelector('.chip[aria-pressed="true"]');
      return on ? on.getAttribute("data-vr-val") : null;
    });
  }

  function variante() {
    var s = elegidas();
    return actual.variants.filter(function (v) {
      return s.every(function (val, i) { return val === null || v.options[i] === val; });
    })[0];
  }

  function refrescar() {
    var v = variante();
    var precio = cuerpo.querySelector("[data-vr-precio]");
    var boton = cuerpo.querySelector("[data-vr-add]");
    if (!v) { return; }
    if (precio) { precio.textContent = plata(v.price); }
    if (boton) {
      boton.disabled = !v.available;
      boton.textContent = v.available ? "Agregar al carrito" : "Agotado";
    }
  }

  cuerpo.addEventListener("click", function (e) {
    var chip = e.target.closest("[data-vr-op]");
    if (chip) {
      var fs = chip.closest(".pdp-opt");
      todos(".chip", fs).forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
      chip.setAttribute("aria-pressed", "true");
      refrescar();
      return;
    }

    var par = e.target.closest("[data-par]");
    if (par) {
      todos("[data-par]").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      par.setAttribute("aria-pressed", "true");
      sel.parche = par.getAttribute("data-par");
      var eti = cuerpo.querySelector("[data-valor]");
      if (eti) { eti.textContent = sel.parche; }
      return;
    }

    var jug = e.target.closest("[data-jug]");
    if (jug) {
      todos("[data-jug]").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      jug.setAttribute("aria-pressed", "true");
      sel.jugador = jug.getAttribute("data-jug");
      sel.dorsal = jug.getAttribute("data-dorsal");
      return;
    }

    var modo = e.target.closest("[data-modo]");
    if (modo) {
      sel.modo = modo.getAttribute("data-modo");
      todos("[data-modo]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === modo)); });
      todos("[data-panel]").forEach(function (pn) {
        pn.hidden = pn.getAttribute("data-panel") !== sel.modo;
      });
    }
  });

  cuerpo.addEventListener("submit", function (e) {
    e.preventDefault();
    var v = variante();
    if (!v) { return; }

    var props = {};
    if (sel.parche && sel.parche !== "Sin parches") { props["Parches"] = sel.parche; }

    var extra = null;
    if (sel.modo === "jugador" && sel.jugador) {
      props["Nombre"] = sel.jugador;
      if (sel.dorsal) { props["Numero"] = sel.dorsal; }
      extra = varJ;
    } else if (sel.modo === "propio") {
      var campo = cuerpo.querySelector("[name='pers-nombre']");
      var campoN = cuerpo.querySelector("[name='pers-numero']");
      var n = campo ? campo.value.trim() : "";
      if (!n) {
        campo.focus();
        campo.classList.add("es-error");
        setTimeout(function () { campo.classList.remove("es-error"); }, 1600);
        return;
      }
      props["Nombre"] = n.toUpperCase();
      if (campoN && campoN.value.trim()) { props["Numero"] = campoN.value.trim(); }
      extra = varP;
    }

    var boton = cuerpo.querySelector("[data-vr-add]");
    boton.disabled = true;
    boton.textContent = "Agregando...";

    var items = [{ id: v.id, quantity: 1, properties: props }];
    if (extra) { items.push({ id: Number(extra), quantity: 1 }); }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { throw new Error("no"); }
      boton.textContent = "Listo, va al carrito";
      setTimeout(function () { location.href = "/cart"; }, 450);
    }).catch(function () {
      boton.disabled = false;
      boton.textContent = "Probar de nuevo";
    });
  });

  function abrir(handle) {
    cuerpo.innerHTML = '<div class="vr-cargando"><span></span><span></span><span></span></div>';
    if (typeof hoja.showModal === "function") { hoja.showModal(); } else { hoja.setAttribute("open", ""); }
    document.documentElement.style.overflow = "hidden";
    traer(handle).then(pintar).catch(function () {
      cuerpo.innerHTML = '<p class="grp-nota" style="padding:26px">No se pudo cargar. Abrí la ficha completa.</p>';
    });
  }
  function cerrar() {
    if (typeof hoja.close === "function") { hoja.close(); } else { hoja.removeAttribute("open"); }
  }
  hoja.addEventListener("close", function () { document.documentElement.style.overflow = ""; });

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-vista]");
    if (b) { e.preventDefault(); abrir(b.getAttribute("data-vista")); return; }
    if (e.target.closest("[data-vr-x]")) { cerrar(); return; }
    if (e.target === hoja) { cerrar(); }
  });
})();
